/**
 * UI-related translations for Portuguese language
 * This file contains translations for common UI elements
 */
export default {
  startPanel: {
    copyLink: 'Copiar link',
    discord: 'Discord',
    leaveGame: 'Sair do Jogo',
    joinGame: 'Entrar no Jogo',
    lockGame: 'Bloquear Jogo',
    unlockGame: 'Desbloquear jogo',
    startGame: 'Iniciar Jogo',
    options: 'Opções',
  },
  onlineStatus: {
    connecting: 'Conectando...',
    connected: 'Conectado',
    error: 'Erro',
  },
  profile: {
    username: 'Nome de usuário',
    stats: 'Estatísticas',
    logout: 'Sair',
    language: 'Idioma',
    hideSpoilersHint: 'Ocultar spoilers',
    hideIndexHint: 'Ocultar Índices no Histórico',
    animeMode: 'Modo anime',
    change: 'Alterar',
    colorTheme: 'Tema de cor',
    darkTheme: 'Tema escuro',
    lightTheme: 'Tema claro',
    changePassword: 'Alterar senha',
    profile: 'Perfil',
    settings: 'Configurações',
  },
  breadCrumbs: {
    merlin: 'Merlin',
    merlin_pure: 'Merlin Puro',
    guinevere: 'Guinevere',
    percival: 'Percival',
    lovers: 'Amantes',
    troublemaker: 'Encrenqueiro',
    servant: 'Servo',
    lancelots: 'Lancelots',
    mordred: 'Mordred',
    trickster: 'Trapaceiro',
    revealer: 'Revelador',
    morgana: 'Morgana',
    oberon: 'Oberon',
    lunatic: 'Lunático',
    brute: 'Bruto',
    witch: 'Bruxa',
    minion: 'Lacaio',
    cleric: 'Clérigo',
    wiki: 'Wiki',
    expansions: 'Expansões',
    roles: 'Papéis',
    lady: 'Dama',
    lady_sea: 'Dama do Mar',
    plot_cards: 'Cartas de Enredo',
    excalibur: 'Excalibur',
    rules: 'Regras',
  },
  hostMenu: {
    host: 'Anfitrião',
    hostPanel: 'Painel do anfitrião',
    endRestartGameHint: 'Os botões iniciarão a votação para o fim ou reinício do jogo',
    endGame: 'Encerrar jogo',
    restartGame: 'Reiniciar jogo',
    shuffle: 'Embaralhar',
    shuffleHint: 'Embaralhar posições dos jogadores no lobby',
  },
  cardsInfo: {
    cards: 'Cartas',
    usedCards: 'Cartas usadas',
    remainingCards: 'Cartas restantes',
    leadToVictory: 'Liderar Para a Vitória',
    leadToVictoryHint: 'Torne-se líder antes da seleção da equipe',
    ambush: 'Emboscada',
    ambushHint: 'Revelar o resultado de uma carta de missão',
    kingReturns: 'O Rei Retorna',
    kingReturnsHint: 'Cancelar uma missão aprovada e passar a liderança para o próximo jogador',
    restoreHonor: 'Restaurar Sua Honra',
    restoreHonorHint: 'Pegar uma carta de enredo de qualquer jogador',
    charge: 'Acusação',
    chargeHint: 'Forçar um jogador a votar publicamente',
    showNature: 'Mostrar Sua Verdadeira Natureza',
    showNatureHint: 'Revelar sua lealdade para outro jogador',
    areYouTheOne: 'Você É O Escolhido',
    areYouTheOneHint: 'Verificar a lealdade do jogador adjacente',
    weFoundYou: 'Nós Te Encontramos',
    weFoundYouHint: 'Forçar um jogador a jogar sua carta de missão virada para cima',
    showStrength: 'Mostrar Sua Força',
    showStrengthHint: 'O líder revela sua lealdade para um jogador',
  },
  avatars: {
    modalHeader: 'Selecionar avatar',
    servantHint: 'Avatar Padrão',
    lady_of_lakeHint: 'Concedido a usuários registrados em 2025',
    mysteryHint: 'Concedido a usuários que encontram o segredo no site',
    merlin_pureHint: 'Concedido por ajudar o projeto com feedback / ajuda na busca de bugs',
    'anime/merlin_pureHint': 'Concedido por fazer qualquer contribuição para o código do projeto no github',
    'anime/witchHint': 'Concedido por alcançar o top-1 de classificação em qualquer papel',
  },
  spoiler: {
    spoiler: 'Spoiler',
    spoilerHint: 'O conteúdo está oculto sob o spoiler, pois contém informações desconhecidas para outros jogadores',
  },
  previewLink: {
    'Minions of Mordred(*)': 'Lacaios de Mordred(*)',
    Minions: 'Lacaios',
  },
  chartStats: {
    countPlayer: '{playerCount} jogadores',
    evilWinrate: 'Taxa de vitória do mal',
    goodWinrate: 'Taxa de vitória do bem',
    winrateByTeamSize: 'Taxas de vitória por tamanho de equipe',
    halfWinrate: 'Taxa de vitória de 50%',
  },
  inGame: {
    sendTeam: 'Enviar Equipe',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    success: 'Sucesso',
    fail: 'Falha',
    checkLoyalty: 'Verificar Lealdade',
    giveExcalibur: 'Dar excalibur',
    skipExcalibur: 'Pular excalibur',
    useExcalibur: 'Usar excalibur',
    useWitchAbility: 'Ocultar missão',
    skipWitchAbility: 'Pular',
    giveCard: 'Dar carta',
    takeLead: 'Assumir liderança',
    skip: 'Pular',
    useCard: 'Usar {cardName}',
    skipCard: 'Pular {cardName}',
    selectPlayer: 'Selecione um jogador',
    selectSinglePlayer: 'Por favor, selecione apenas um jogador',
    cannotSelectSelf: 'Você não pode selecionar a si mesmo',
    takeCard: 'Pegar carta',
    selectCard: 'Selecione uma carta',
    noAvailableCards: 'Sem cartas disponíveis',
    revealLoyalty: 'Revelar Lealdade',
  },
};
